<template>
    <div id="layout_main">
        <div id="layout_top" class="bg-main">
            <top-nav-default></top-nav-default>
        </div>
        <div id="layout_bottom">
            <div id="layout_left" class="bg-faded">
                <left-nav-default></left-nav-default>
            </div>
            <div id="layout_right" class="bg-white">
                <slot v-if="isPermitted"></slot>
                <div v-else class="fs-normal fc-gray-dark ff-inter">
                    <i class="fas fa-exclamation-triangle"></i>
                    No Project selected
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Joat from '../miscellaneous/joat'
  import UserInfo from '../miscellaneous/userInfo'
  import LeftNavDefault from '../navs/leftNavDefault'
  import TopNavDefault from '../navs/topNavDefault'
  export default {
    name: 'Default',
    components: { TopNavDefault, LeftNavDefault, UserInfo, Joat },
    props: {
        needsProject:{
          type: Boolean,
          default: false
        }
    },
    data(){
      return{

      }
    },
    computed: {
      project(){
        return this.$store.getters['Projects/get_project']
      },
      isPermitted(){
        return this.needsProject ? this.project : true;
      }
    }
  }
</script>

<style scoped>
    #layout_main{
        --layout-left-width: 250px;
        --layout-middle-width: calc(100% - var(--layout-left-width));
        --layout-top-height: 50px;
        --layout-padding: 10px;

        display: flex;
        height: 100%;
        width: 100%;
        overflow: hidden;
        flex-direction: column;
    }
    #layout_top{
        display: flex;
        width: 100%;
        height: var(--layout-top-height);
    }
    #layout_bottom{
        display: flex;
        width: 100%;
        height: calc(100% - var(--layout-top-height));
    }
    #layout_left{
        display: flex;
        height: 100%;
        width: var(--layout-left-width);
        border-right: 1px solid var(--color-gray);
    }
    #layout_right{
        display: flex;
        height: calc(100% - var(--layout-padding) * 2);
        width: calc(100% - var(--layout-left-width) - var(--layout-padding) * 2);
        padding: var(--layout-padding);
    }
</style>
